import React, { useContext } from 'react';
import { Periods } from '../../../../../constants';
import { DownloadReportsModel, EmployeeNodeModel } from '../../../../../models';
import { getEmployeesIds } from '../../../../../utils';
import { AppContext } from '../../../../context';
import { ReportItem } from '../MenuItem';
import { handleDownloadReport } from '../../../../../utils/handleDownloadReport';

interface Props {
    handlerSaveReportByPeriod: (
        period: number,
        periodName: string,
        name: string,
        url: string
    ) => void;
    startDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
    endDateScheduling: string;
}

export const WorkshiftMenuGroup: React.FC<Props> = ({
    handlerSaveReportByPeriod,
    endDateScheduling,
    selectedEmployees,
    startDateScheduling,
}) => {
    const { langResources, downloadReport } = useContext(AppContext);

    /**
     * Descarga el reporte de Historial de Solicitudes por Autorizador
     */
    const handlerSaveReportWorkshiftsII = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Historial de solicitudes por Autorizador',
            '/jerusalem/api/v2.0.0/reports/get-requests-history-by-authorizer',
            downloadReport
        );
    };

    const reportPeriods = [
        {
            period: Periods.WEEKLY,
            label: langResources['header.reports.weekly'],
            name: 'Semanal',
        },
        {
            period: Periods.BIWEEKLY,
            label: langResources['header.reports.biweekly'],
            name: 'Quincenal',
        },
        {
            period: Periods.MONTHLY,
            label: langResources['header.reports.monthly'],
            name: 'Mensual',
        },
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>{langResources['header.reports.workshift.item']}</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

            <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-4'>
                    {reportPeriods.map(({ period, label, name }) => (
                        <ReportItem
                            key={period}
                            label={label}
                            handler={() =>
                                handlerSaveReportByPeriod(
                                    period,
                                    name,
                                    'Turnos',
                                    'workshift-scheduling-by-period'
                                )
                            }
                        />
                    ))}

                    <li className='nac-item text-dark'>
                        <a
                            className='nav-link text-dark'
                            href='#'
                            onClick={handlerSaveReportWorkshiftsII}
                        >
                            {langResources['header.reports.workshift.scheduled.II']}
                        </a>
                    </li>
                </ul>
            </div>
        </li>
    );
};
